import {
  formatMoney,
  formatMoneyRaw,
  formatText,
  formatTextRaw,
  formatDate,
  toCsvLine,
  parseSections,
  renderStatementDocument,
  infoRow,
} from "../../../../data/Reports/statementHtmlKit";

export const buildCustomerStatementHtml = ({ rawResults, generatedAt }) => {
  const sections = parseSections(rawResults);
  const header = sections.find((s) => s.Format === "header")?.Data || {};
  const summary = sections.find((s) => s.Format === "summary")?.Data || {};
  const bbf = sections.find((s) => s.Format === "sectioned")?.Data || null;
  const tableRows = sections
    .filter((s) => s.Format === "table" && s.Section !== "Charges & Fees")
    .map((s) => s.Data);
  const chargeRows = sections
    .filter((s) => s.Format === "table" && s.Section === "Charges & Fees")
    .map((s) => s.Data);

 const summaryFields = [
  ["Total Disbursed", summary.TotalDisbursed],
  ["Total Repaid", summary.TotalRepaid],
  ["Interest Paid", summary.TotalInterest],
  ["Principal Paid", summary.TotalPrincipal],
  ["Penalties / Fees", summary.TotalPenalty],
  ["Interest Waived", summary.TotalInterestWaived],
  ["Savings Balance", summary.CustomerSavings],
];

  const summaryRowsHtml = summaryFields
    .map(
      ([label, value]) => `
          <tr>
            <td>${label}</td>
            <td class="amount">${formatMoney(value)}</td>
          </tr>`
    )
    .join("");

  const bbfCard = bbf
    ? `
    <div class="section">
      <h2 class="section-title">Balance Brought Forward</h2>
      <table class="bordered-table">
        <thead>
          <tr><th>Loan Balance</th><th>Disbursed Amount</th><th>Arrears</th></tr>
        </thead>
        <tbody>
          <tr>
            <td class="amount">${formatMoney(bbf.LoanBalance)}</td>
            <td class="amount">${formatMoney(bbf.DisbursedAmount)}</td>
            <td class="amount">${formatMoney(bbf.Arrears)}</td>
          </tr>
        </tbody>
      </table>
    </div>`
    : "";

  const csvSections = [];
  csvSections.push([toCsvLine(["Customer Statement"])]);
  csvSections.push([
    toCsvLine(["Customer Name", formatTextRaw(header.CustomerName)]),
    toCsvLine(["Mobile Number", formatTextRaw(header.MobileNumber)]),
    toCsvLine(["ID Number", formatTextRaw(header.IDNumber)]),
    toCsvLine(["Customer ID", formatTextRaw(header.CustomerId)]),
    toCsvLine(["Statement Period", formatTextRaw(header.StatementPeriod)]),
  ]);
  csvSections.push([
    toCsvLine(["SUMMARY"]),
    toCsvLine(["Metric", "Amount (KES)"]),
    ...summaryFields.map(([label, value]) =>
      toCsvLine([label, formatMoneyRaw(value)])
    ),
    toCsvLine(["Outstanding Balance", formatMoneyRaw(summary.OutstandingBalance)]),
  ]);

  if (bbf) {
    csvSections.push([
      toCsvLine(["BALANCE BROUGHT FORWARD"]),
      toCsvLine(["Loan Balance", "Disbursed Amount", "Arrears"]),
      toCsvLine([
        formatMoneyRaw(bbf.LoanBalance),
        formatMoneyRaw(bbf.DisbursedAmount),
        formatMoneyRaw(bbf.Arrears),
      ]),
    ]);
  }

const detailCsvRows = [
  [
    "Date",
    "Description",
    "Reference",
    "MoneyIn",
    "MoneyOut",
    "Interest",
    "Principal",
    "Penalty",
    "InterestWaived",
  ],
];

  const tableBodyRows = tableRows
    .map((row) => {
      const rowType = row.RowType;
      if (rowType === "Disbursement") {
        detailCsvRows.push([
          formatTextRaw(row.TransactionDate),
          formatTextRaw(row.Description),
          "N/A",
          formatMoneyRaw(row.MoneyIn),
          formatMoneyRaw(row.MoneyOut),
          formatMoneyRaw(row.InterestPaid),
          formatMoneyRaw(row.PrincipalPaid),
          formatMoneyRaw(row.PenaltyPaid),
        ]);
        return `
          <tr>
            <td>${formatDate(row.TransactionDate)}</td>
            <td>${formatText(row.Description)}</td>
            <td>N/A</td>
            <td class="amount money-in">${formatMoney(row.MoneyIn)}</td>
            <td class="amount">${formatMoney(row.MoneyOut)}</td>
            <td class="amount">${formatMoney(row.InterestPaid)}</td>
            <td class="amount">${formatMoney(row.PrincipalPaid)}</td>
            <td class="amount">${formatMoney(row.PenaltyPaid)}</td>
          </tr>`;
      }
      if (rowType === "Repayment") {
        detailCsvRows.push([
          formatTextRaw(row.TransactionDate),
          formatTextRaw(row.Description),
          formatTextRaw(row.Reference),
          formatMoneyRaw(row.MoneyIn),
          formatMoneyRaw(row.MoneyOut),
          formatMoneyRaw(row.InterestPaid),
          formatMoneyRaw(row.PrincipalPaid),
          formatMoneyRaw(row.PenaltyPaid),
        ]);
        return `
          <tr>
            <td>${formatDate(row.TransactionDate)}</td>
            <td>${formatText(row.Description)}</td>
            <td>${formatText(row.Reference)}</td>
            <td class="amount">${formatMoney(row.MoneyIn)}</td>
            <td class="amount money-out">${formatMoney(row.MoneyOut)}</td>
            <td class="amount">${formatMoney(row.InterestPaid)}</td>
            <td class="amount">${formatMoney(row.PrincipalPaid)}</td>
            <td class="amount">${formatMoney(row.PenaltyPaid)}</td>
          </tr>`;
      }
      if (rowType === "Allocation") {
        const loanRef = row.LoanId ? `Loan ${row.LoanId}` : null;
        detailCsvRows.push([
          formatTextRaw(row.TransactionDate),
          "Payment Breakdown",
          formatTextRaw(loanRef),
          formatMoneyRaw(row.MoneyIn),
          formatMoneyRaw(row.MoneyOut),
          formatMoneyRaw(row.InterestPaid),
          formatMoneyRaw(row.PrincipalPaid),
          formatMoneyRaw(row.PenaltyPaid),
        ]);
        return `
          <tr class="allocation-row">
            <td>${formatDate(row.TransactionDate)}</td>
            <td class="indent">↳ Payment Breakdown</td>
            <td>${formatText(loanRef)}</td>
            <td class="amount">${formatMoney(row.MoneyIn)}</td>
            <td class="amount">${formatMoney(row.MoneyOut)}</td>
            <td class="amount">${formatMoney(row.InterestPaid)}</td>
            <td class="amount">${formatMoney(row.PrincipalPaid)}</td>
            <td class="amount">${formatMoney(row.PenaltyPaid)}</td>
          </tr>`;
      }
      if (rowType === "Interest Waived") {
  detailCsvRows.push([
    formatTextRaw(row.TransactionDate),
    formatTextRaw(row.Description),
    "N/A",
    formatMoneyRaw(row.MoneyIn),
    formatMoneyRaw(row.MoneyOut),
    formatMoneyRaw(row.InterestPaid),
    formatMoneyRaw(row.PrincipalPaid),
    formatMoneyRaw(row.PenaltyPaid),
    formatMoneyRaw(row.InterestWaived),
  ]);
  return `
    <tr class="waiver-row">
      <td>${formatDate(row.TransactionDate)}</td>
      <td>${formatText(row.Description)}</td>
      <td>N/A</td>
      <td class="amount">${formatMoney(row.MoneyIn)}</td>
      <td class="amount">${formatMoney(row.MoneyOut)}</td>
      <td class="amount">${formatMoney(row.InterestPaid)}</td>
      <td class="amount">${formatMoney(row.PrincipalPaid)}</td>
      <td class="amount">${formatMoney(row.PenaltyPaid)}</td>
      <td class="amount money-waived">${formatMoney(row.InterestWaived)}</td>
    </tr>`;
}
      return "";
    })
    .join("");

  csvSections.push([
    toCsvLine(["STATEMENT DETAILS"]),
    ...detailCsvRows.map(toCsvLine),
  ]);

  const chargeRowsHtml = chargeRows
    .map(
      (row) => `
          <tr>
            <td>${formatDate(row.ChargeDate)}</td>
            <td>${formatText(row.ChargeName)}</td>
            <td>${formatText(row.LoanId)}</td>
            <td>${formatText(row.Description)}</td>
            <td class="amount">${formatMoney(row.Amount)}</td>
          </tr>`
    )
    .join("");

  if (chargeRows.length > 0) {
    csvSections.push([
      toCsvLine(["CHARGES & FEES"]),
      toCsvLine(["ChargeDate", "ChargeName", "LoanId", "Description", "Amount"]),
      ...chargeRows.map((row) =>
        toCsvLine([
          formatTextRaw(row.ChargeDate),
          formatTextRaw(row.ChargeName),
          formatTextRaw(row.LoanId),
          formatTextRaw(row.Description),
          formatMoneyRaw(row.Amount),
        ])
      ),
    ]);
  }

  const csvContent = csvSections
    .map((lines) => lines.join("\r\n"))
    .join("\r\n\r\n");

  const csvFileName = `Customer_Statement_${(header.CustomerId ?? "")
    .toString()
    .replace(/\s+/g, "_")}.csv`;

  const infoRowsHtml = [
    infoRow("Customer Name", formatText(header.CustomerName)),
    infoRow("Mobile Number", formatText(header.MobileNumber)),
    infoRow("ID Number", formatText(header.IDNumber)),
    infoRow("Customer ID", formatText(header.CustomerId)),
    infoRow("Statement Period", formatText(header.StatementPeriod)),
  ].join("");

  const bodyHtml = `
    <div class="section">
      <h2 class="section-title">Summary</h2>
      <table class="bordered-table">
        <thead>
          <tr><th>Metric</th><th style="text-align:right;">Amount (KES)</th></tr>
        </thead>
        <tbody>
          ${summaryRowsHtml}
          <tr class="total-row">
            <td>Outstanding Balance</td>
            <td class="amount">${formatMoney(summary.OutstandingBalance)}</td>
          </tr>
        </tbody>
      </table>
    </div>

    ${bbfCard}

    <div class="section">
      <h2 class="section-title">Statement Details</h2>
      <div class="table-wrap">
        <table class="bordered-table detail-table">
          <colgroup>
            <col class="col-date" />
            <col class="col-desc" />
            <col class="col-ref" />
            <col class="col-money" />
            <col class="col-money" />
            <col class="col-money" />
            <col class="col-money" />
            <col class="col-money" />
          </colgroup>
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Reference</th>
              <th style="text-align:right;">Money In</th>
              <th style="text-align:right;">Money Out</th>
              <th style="text-align:right;">Interest</th>
              <th style="text-align:right;">Principal</th>
              <th style="text-align:right;">Penalty</th>
              <th style="text-align:right;">Interest<br/>Waived</th>
            </tr>
          </thead>
          <tbody>
            ${
              tableBodyRows ||
              `<tr><td colspan="9" style="text-align:center;padding:16px;">No transactions found for the selected period.</td></tr>`
            }
          </tbody>
        </table>
      </div>
    </div>

    ${
      chargeRows.length > 0
        ? `
    <div class="section">
      <h2 class="section-title">Charges &amp; Fees</h2>
      <div class="table-wrap">
        <table class="bordered-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Charge</th>
              <th>Loan</th>
              <th>Description</th>
              <th style="text-align:right;">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${chargeRowsHtml}
          </tbody>
        </table>
      </div>
    </div>`
        : ""
    }`;

  return renderStatementDocument({
    docTitle: `Customer Statement - ${formatTextRaw(header.CustomerName)}`,
    pageTitle: "Customer Account Statement",
    generatedAt,
    infoRowsHtml,
    bodyHtml,
    csvContent,
    csvFileName,
  });
};
